import React from "react";
import walmart from "../assets/logos/walmart.webp";
import walmartE from "../assets/logos/walmartE.webp";
import tcs from "../assets/logos/tcs.webp";
import tcsE from "../assets/logos/tcsE.webp";
function Experience() {
  return (
    <section id="experience">
      <div className="section__title">Experience</div>
      <div className="container pt-0 pl-4 md:pl-0">
        <div className="flex relative flex-col gap-8 py-12 w-full h-full">
          {/* timeline */}
          <div className="w-[1px] h-full absolute top-0 left-0 md:left-1/2 bg-leetcodeBorderColor flex ">
            <div className="absolute top-0 left-0 w-4 h-4 rounded-full -translate-x-1/2 -translate-y-1/2 bg-firstColor before:w-3 before:h-3 before:absolute before:top-1/2 before:left-1/2 before:bg-containerColor before:dark:bg-darkContainerColor before:-translate-x-1/2 before:-translate-y-1/2 before:rounded-full"></div>
            <div className="absolute bottom-0 left-0 w-4 h-4 rounded-full -translate-x-1/2 translate-y-1/2 bg-firstColor before:w-3 before:h-3 before:absolute before:top-1/2 before:left-1/2 before:bg-containerColor before:dark:bg-darkContainerColor before:-translate-x-1/2 before:-translate-y-1/2 before:rounded-full"></div>
          </div>
          {/* box1 */}
          <div className="grid relative left-0 place-items-center w-full md:w-1/2">
            <div className=" bg-containerColor dark:bg-darkContainerColor  relative z-20 w-[85%] rounded-xl ">
              <div className="flex flex-col gap-4 p-8">
                <span className="capitalize text-firstColor dark:text-firstColor section__contentSubTitle">
                  Jul, 2022-Present
                </span>
                <div className="flex flex-col gap-2 justify-between items-center md:flex-row">
                  <div className="flex flex-col gap-2 items-center md:items-start">
                    <span className="capitalize section__subtitle">
                      Lead Developer (SDE-IV)
                    </span>
                    <span className="text-base capitalize align-middle section__contentTitle sm:text-lg lg:text-xl">
                      Walmart Global Tech
                    </span>
                  </div>
                  <img
                    className="w-[30%] md:w-[25%] "
                    src={walmartE}
                    alt="walmart"
                  />
                </div>
                <ul className="section__content flex flex-col gap-2 list-[circle] ">
                  <li>
                    Led the development of the Walmart Seller Portal with a
                    strong focus on repricer, promotions, and discounts.
                  </li>
                  <li>
                    Directed the complete revamp of the discounts module,
                    introducing promo codes, extra savings, and buy more–save
                    more, which improved seller engagement by over{" "}
                    <span className="text-black dark:text-white">35%</span>.
                  </li>
                  <li>
                    Re-architected promotion services and UI workflows,
                    improving perceived application responsiveness by{" "}
                    <span className="text-black dark:text-white">40%</span>.
                  </li>
                  <li>
                    Ensured timely delivery of critical features, earning
                    appreciation from Walmart leadership and recognition at
                    global seller summits.
                  </li>
                  <li>
                    Provided technical leadership across teams—mentoring
                    engineers and establishing coding standards for
                    maintainable solutions.
                  </li>
                  <span className="-ml-4 font-bold text-white underline">
                    Key Achievement
                  </span>
                  <li>
                    Successfully led multiple strategic feature rollouts in the
                    Seller Portal, positioning it as a more competitive and
                    reliable platform for Walmart sellers.
                  </li>
                  <span className="mt-2 -ml-4 section__subtitle">
                    Front End Developer (SDE-III)
                  </span>
                  <li>
                    Worked on the Walmart Survey Builder platform,{" "}
                    <a
                      href="https://feedbackally.walmart.com"
                      className="text-black dark:text-white lg:cursor-pointer"
                    >
                      FeedbackAlly
                    </a>
                    , enabling customers to create surveys for internal and
                    external audiences.
                  </li>
                  <li>
                    Implemented advanced features like drag & drop, data piping,
                    and modernized React components in the survey creator flow.
                  </li>
                  <li>
                    Launched AES survey which received over 1M responses, saving
                    around{" "}
                    <span className="text-black dark:text-white">$250K</span>{" "}
                    from outsourcing.
                  </li>
                  <li>
                    Decommissioned oneWire product, saving around{" "}
                    <span className="text-black dark:text-white">$40K</span>{" "}
                    annually.
                  </li>
                  <span className="-ml-4 font-bold text-white underline">
                    Key Achievement
                  </span>
                  <li>
                    Resolved critical blockers in FeedbackAlly using CKEditor
                    custom build support, achieving significant cost savings
                    and receiving the Excellence Award.
                  </li>
                </ul>
              </div>
            </div>
            <div className="flex absolute left-0 top-1/3 z-20 justify-center items-center w-11 h-11 rounded-full -translate-x-1/2 -translate-y-1/2 md:left-full md:cursor-pointer">
              <img
                className="w-full h-full rounded-full hover:rotate-[360deg] transition-transform duration-500"
                src={walmart}
                alt="walmart"
              />
            </div>
            <div className="h-[1px] w-28 bg-leetcodeBorderColor absolute top-1/3 left-0 md:left-full md:-translate-x-[100%] z-10 "></div>
          </div>
          {/* box2 */}
          <div className="grid relative left-0 place-items-center w-full md:w-1/2 md:left-1/2">
            <div className=" bg-containerColor dark:bg-darkContainerColor relative z-20 w-[85%] rounded-xl">
              <div className="flex flex-col gap-4 p-8">
                <span className="capitalize text-firstColor dark:text-firstColor section__contentSubTitle">
                  Feb, 2020 - Jul, 2022
                </span>
                <div className="flex flex-col gap-2 justify-between items-center md:flex-row">
                  <div className="flex flex-col gap-2 items-center md:items-start">
                    <span className="capitalize section__subtitle">
                      Front end developer
                    </span>
                    <span className="text-base capitalize align-middle section__contentTitle sm:text-lg lg:text-xl">
                      Tata Consultancy Services
                    </span>
                  </div>
                  <img className="w-[15%] " src={tcsE} alt="tcs logo" />
                </div>
                <ul className="section__content flex flex-col gap-2 list-[circle] ">
                  <li>
                    Building stable and maintainable codebases using ReactJS.
                  </li>
                  <li>
                    Involving in building multiple UI components from design
                    stage to production stage.
                  </li>
                  <li>
                    Developed user interactive and responsive web pages in
                    professional manner by using modern web technologies.
                  </li>
                  <li>
                    Worked in an agile environment with weekly stand-ups, kept
                    track of user stories/bugs in projects.
                  </li>
                  <span className="-ml-4 font-bold text-white underline">
                    Key Achievement
                  </span>
                  <li>
                    Completely transformed an existing .Net application into
                    Java Script application which is focused with function-based
                    approach. This project was a key point during the renewal of
                    contract with customer on 2021.
                  </li>
                </ul>
              </div>
            </div>
            <div className="flex absolute left-0 top-1/3 z-20 justify-center items-center w-11 h-11 rounded-full -translate-x-1/2 -translate-y-1/2 md:cursor-pointer">
              <img
                className="w-full h-full rounded-full hover:rotate-[360deg] transition-transform duration-500"
                src={tcs}
                alt="tcs"
              />
            </div>
            <div className="h-[1px] w-28 bg-leetcodeBorderColor absolute top-1/3 left-0   z-10 "></div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Experience;
